// Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React from 'react'
import { Redirect } from 'react-router-dom'

// mobx
import { observer } from 'mobx-react'

// fragments
import { fragments } from 'services/get-fragments'
import { isAuthenticated } from 'services/self'

// semantic-ui
import { Segment, Container } from 'semantic-ui-react'

export default observer(class FAQ extends React.Component {
  render() {
    return !isAuthenticated() ? <Redirect to='/' /> : (
      <Container style={{ padding: "40px" }}>
        <Segment vertical textAlign='left' >
          <fragments.FAQ.jsx />
        </Segment>
      </Container>
    )
  }
})
